import {
    AddPropertiesExpandParameter,
    ParseReplacementProductData as ParseReplacementData,
} from "@gemeco/Handlers/Utilities";
import { addToChainAfter, addToChainBefore } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchCompleteLoadProducts,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";

export type HandlerType = Parameters<typeof DispatchCompleteLoadProducts>[0];

addToChainAfter(chain, PopulateApiParameter, AddPropertiesToExpand);

function AddPropertiesToExpand(props: HandlerType) {
    AddPropertiesExpandParameter(props.apiParameter);
}

addToChainBefore(chain, DispatchCompleteLoadProducts, ParseReplacementProductData);

function ParseReplacementProductData(props: HandlerType) {
    if (props.apiResult.products) {
        for (const product of props.apiResult.products) {
            ParseReplacementData(product);
        }
    }
}
